// eslint-disable-next-line no-magic-numbers
export const PAGE_SIZES = [25, 50, 75, 100];
